import React, { useEffect, useState, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
  getEnvelopeSenderList,
  getDocuments,
  addkeyword,
  deletekeyword,
  searchKeyword,
  getManageEnvelopeList,
  sleeveFileDetailsForm,
  sleeveFilePreviewDetailsForm,
  checkMyFilesEnabled // <-- add import
} from "../../../../services/CommonService";
import Utils from "../../../../utils";
import { FaTimes } from "react-icons/fa";
import { Button } from "react-bootstrap";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import mammoth from "mammoth";
import { toast } from "react-toastify";
import useDocumentCounts from "./useDocumentCounts";
import DocumentForm from "./Files/DocumentForm";
import Pagination from "react-js-pagination";
import { commonFields, documentFields } from "./Files/DocumentForm";
import { CiGrid41, CiBoxList } from "react-icons/ci";
import { BsLightningChargeFill } from "react-icons/bs";
import { RiFileList3Line } from "react-icons/ri";
import { FaRegFile } from "react-icons/fa";
import PasteToMyFilesModal from "./ViewEnvFiles/PasteToMyFilesModal";
import EnvFilesFolderView from "./EnvFilesFolderView";
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import PowerPointPreview from "../../../../components/PowerPointPreview";
import ExcelPreview from "../../../../components/ExcelPreview";

const styles = `
  .smart-sleeve-badge {
    display: inline-flex;
    align-items: center;
    background: #fffbe6;
    color: #b28704;
    border: 1px solid #ffe082;
    border-radius: 10px;
    font-size: 0.78em;
    font-weight: 600;
    padding: 0 7px 0 5px;
    // margin-left: 6px;
    height: 1.5em;
    line-height: 1.5em;
    vertical-align: middle;
    cursor: pointer;
  }
  .smart-sleeve-badge i {
    margin-right: 3px;
    font-size: 1em;
    color: #ffc107;
    vertical-align: middle;
  }
  .sleeve-name-ellipsis {
    display: inline-block;
    max-width: 140px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
  @media (max-width: 900px) {
    .sleeve-name-ellipsis { max-width: 80px; }
  }
  .compact-table th, .compact-table td {
    padding: 6px 8px !important;
  }
 
`;

const EnvFiles = () => {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  // Fix: userData ko define karo
  const userData = Utils.loginUserData();
  const [myFilesEnabled, setMyFilesEnabled] = useState(null); // <-- add state

  const [totalSleeveFile, setTotalSleeveFiles] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [dataParams, setDataParams] = useState({
    limit: 10,
    page: 1,
  });
  const [envelopeList, setEnvelopeList] = useState([]);
  const [envelopeProcess, setEnvelopeProcess] = useState("loading...");
  const [fetchedDocuments, setFetchedDocuments] = useState([]);
  const [errorMessages, setErrorMessages] = useState({});
  const [tagInputs, setTagInputs] = useState({});
  const [tagModal, setTagModal] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [envelopeId, setEnvelopeId] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [selectedDocForPreview, setSelectedDocForPreview] = useState(null);
  const [userId, setUserId] = useState(null);
  const [senderList, setSenderList] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [tags, setTags] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const [formOffcanvasOpen, setFormOffcanvasOpen] = useState(false);
  const [detailsOffcanvasOpen, setDetailsOffcanvasOpen] = useState(false);
  const [selectedFormDoc, setSelectedFormDoc] = useState(null);
  const [formData, setFormData] = useState({});
  const [formDetails, setFormDetails] = useState({});
  const [documentType, setDocumentType] = useState("");
  const [totalDocuments, setTotalDocuments] = useState(0);
  const [storedFileId, setStoredFileId] = useState(null);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [editorDoc, setEditorDoc] = useState(null);
  const [viewMode, setViewMode] = useState("folder");
  const [sleeveSmartFoldersData, setSleeveSmartFoldersData] = useState({});
  const [fileFilterType, setFileFilterType] = useState("all");
  const [selectedRows, setSelectedRows] = useState([]);
  const [showCopyModal, setShowCopyModal] = useState(false);

  const {
    counts: { totalInProgress, totalDraft, totalCompleted, },
    setTotalInProgress,
    setTotalDraft,
    setTotalCompleted,
    loading,
    setLoading,
  } = useDocumentCounts({ userEmail: Utils.loginUserData()?.email, selectedUserId, dataParams, userId });

  useEffect(() => {
    getEnvelopeSenderList()
      .then((response) => {
        const senderData = response.data.data;
        setSenderList(senderData);
        if (senderData.length > 0 && senderData[0].id) {
          setSelectedUserId(Number(senderData[0].id));
        }
      })
      .catch((err) => {
        // toast.error("Failed to fetch sender list!");
      });
    // Check MyFiles enabled status
    checkMyFilesEnabled({})
      .then(res => {
        if (res.data && typeof res.data.data?.myfiles_enabled !== 'undefined') {
          setMyFilesEnabled(res.data.data.myfiles_enabled);
        } else {
          setMyFilesEnabled(false);
        }
      })
      .catch(err => {
        setMyFilesEnabled(false);
      });
  }, []);

  // Filtered documents based on fileFilterType and search text
  const filteredAndSearchedDocuments = useMemo(() => {
    let filtered = fetchedDocuments;

    // Apply file type filter
    if (fileFilterType === "normal") {
      filtered = filtered.filter(doc => !doc.is_smart_sleeve);
    } else if (fileFilterType === "smart") {
      filtered = filtered.filter(doc => doc.is_smart_sleeve);
    }

    // Apply search text filter (existing logic)
    const allSearchTerms = [...(searchText ? [searchText.trim()] : []), ...tags].filter((term) => term.trim());
    if (allSearchTerms.length > 0) {
      const escapedTerms = allSearchTerms.map((term) => term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
      const regex = new RegExp(`(${escapedTerms.join("|")})`, "gi");
      filtered = filtered.filter(doc =>
        (doc.sleeve_name && regex.test(String(doc.sleeve_name))) ||
        (doc.file_name && regex.test(String(doc.file_name))) ||
        (doc.keywords && doc.keywords.some(keyword => regex.test(String(keyword))))
      );
    }

    return filtered;
  }, [fetchedDocuments, fileFilterType, searchText, tags]);

  // Paginate the filtered and searched documents
  const paginatedDocuments = filteredAndSearchedDocuments.slice(
    (dataParams.page - 1) * dataParams.limit,
    dataParams.page * dataParams.limit
  );

  // Handler for pagination-related changes
  const handleData = (e, type) => {
    let params = { ...dataParams };
    if (type === "pagination") {
      params.page = e;
    } else if (type === "limit") {
      params.limit = parseInt(e.target.value);
      params.page = 1; // Reset to first page when limit changes
    }
    setDataParams(params);
    // Re-fetch documents if limit changes, otherwise rely on memoized filtered data
    if (type === "limit") {
      fetchDocuments(searchText, params.page, params.limit);
    } else {
      // For pagination changes, totalDocuments needs to reflect the filtered count
      setTotalDocuments(filteredAndSearchedDocuments.length);
    }
  };

  const lengths = Utils.tableShowLengths();

  const handleOpenFormOffcanvas = async (selectedDoc) => {
    if (!selectedDoc || !selectedDoc.envelope_id) {
      toast.error("Invalid document selected.");
      return;
    }

    setSelectedFormDoc(selectedDoc);
    setStoredFileId(selectedDoc.id);
    setDocumentType(selectedDoc.document_type || "");

    try {
      setFormLoading(true);
      const payload = {
        user_id: Number(selectedUserId),
        envelope_id: Number(selectedDoc.envelope_id),
        file_name: selectedDoc.file_name,
      };
      const response = await sleeveFilePreviewDetailsForm(payload);
      const fetchedDetails = response?.data?.formDetails || {};

      if (Object.keys(fetchedDetails).length > 0) {
        setFormData({
          ...fetchedDetails,
          additional_data: fetchedDetails.additional_data || {},
        });
      } else {
        setFormData({ document_type: selectedDoc.document_type || "" });
      }
    } catch (error) {
      console.error("Error fetching document details:", error);
      setFormData({ document_type: selectedDoc.document_type || "" });
    } finally {
      setFormLoading(false);
      setFormOffcanvasOpen(true);
    }
  };

  const handleCloseFormOffcanvas = () => {
    setFormOffcanvasOpen(false);
    setSelectedFormDoc(null);
    setDocumentType("");
    setFormData({});
  };

  const handleOpenDetailsOffcanvas = async (selectedDoc) => {
    if (!selectedDoc || !selectedDoc.envelope_id) {
      toast.error("Invalid document selected or envelope ID missing.");
      return;
    }

    setSelectedFormDoc(selectedDoc);
    setDocumentType(selectedDoc.document_type || "");

    try {
      setFormLoading(true);
      const payload = {
        user_id: Number(selectedUserId),
        envelope_id: Number(selectedDoc.envelope_id),
        file_name: selectedDoc.file_name,
      };
      const response = await sleeveFilePreviewDetailsForm(payload);
      const fetchedDetails = response?.data?.formDetails || {};

      if (Object.keys(fetchedDetails).length > 0) {
        setFormDetails(fetchedDetails);
      } else {
        setFormDetails({
          user_id: Number(selectedUserId),
          envelope_id: Number(selectedDoc.envelope_id),
          file_name: selectedDoc.file_name,
          document_type: selectedDoc.document_type || "",
          additional_data: {},
        });
      }
    } catch (error) {
      console.error("Error fetching document details:", error);
      setFormDetails({
        user_id: Number(selectedUserId),
        envelope_id: Number(selectedDoc.envelope_id),
        file_name: selectedDoc.file_name,
        document_type: selectedDoc.document_type || "",
        additional_data: {},
      });
    } finally {
      setFormLoading(false);
      setDetailsOffcanvasOpen(true);
    }
  };

  const handleCloseDetailsOffcanvas = () => {
    setDetailsOffcanvasOpen(false);
    setSelectedFormDoc(null);
    setFormDetails({});
  };

  const handleSubmitForm = async (formData) => {
    if (!selectedFormDoc || !selectedFormDoc.envelope_id) {
      toast.error("No valid document selected for submission.");
      return;
    }

    try {
      setFormLoading(true);

      const cleanedFormData = {
        document_type: formData.document_type === "N/A" || !formData.document_type ? null : formData.document_type,
        document_number: formData.document_number || "",
        owner_name: formData.owner_name || "",
        remarks: formData.remarks || "",
        address: formData.address || "",
        additional_data: formData.additional_data || {},
      };

      const formDataToSend = {
        user_id: Number(selectedUserId),
        envelope_id: Number(selectedFormDoc.envelope_id),
        file_name: selectedFormDoc.file_name,
        ...cleanedFormData,
      };

      if (selectedFormDoc.hasDetails) {
        formDataToSend._method = "PUT";
      }

      const response = await sleeveFileDetailsForm(formDataToSend);

      setFetchedDocuments((prev) =>
        prev.map((doc) =>
          doc.id === selectedFormDoc.id
            ? { ...doc, hasDetails: true, ...cleanedFormData }
            : doc
        )
      );

      setFormDetails(formDataToSend);

      toast.success(response.data.message || "Document details saved successfully!");
    } catch (error) {
      console.error("Error saving document details:", error);
      // toast.error(error.response?.data?.message || "Failed to save document details!");
    } finally {
      setFormLoading(false);
      setFormOffcanvasOpen(false);
    }
  };

  const handleSearchChange = (value) => {
    setSearchText(value);
    // Trigger re-filtering and pagination through filteredAndSearchedDocuments useMemo
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (name === "document_type") setDocumentType(value);
  };

  useEffect(() => {
    const userData = Utils.loginUserData();
    if (userData && userData.id) setUserId(userData.id);
  }, []);

  useEffect(() => {
    setEnvelopeList([]);
    setEnvelopeProcess("loading...");
    getManageEnvelopeList(dataParams)
      .then((response) => {
        setTotalData(parseInt(response.data.count));
        setEnvelopeList(response.data.data);
        if (response.data.data.length === 0) setEnvelopeProcess("No data available.");
        if (response.data.status_count.length > 0) {
          if (response.data.status_count[0]) setTotalInProgress(parseInt(response.data.status_count[0]));
          if (response.data.status_count[1]) setTotalDraft(parseInt(response.data.status_count[1]));
          if (response.data.status_count[2]) setTotalCompleted(parseInt(response.data.status_count[2]));
        }
      })
      .catch(() => setEnvelopeProcess("No data available."));
  }, [dataParams, userId]);

  useEffect(() => {
    if (selectedUserId) {
      fetchDocuments(searchText, dataParams.page, dataParams.limit);
    }
  }, [selectedUserId]); // Removed dataParams.limit from here, as pagination is handled via useMemo

  const saveKeyword = (filePath, keywordValue) => {
    const trimmedKeywordValue = keywordValue.trim();
    if (!trimmedKeywordValue) return;

    const currentDoc = fetchedDocuments.find((doc) => doc.file_path === filePath);
    if (!currentDoc || currentDoc.keywords.includes(trimmedKeywordValue) || currentDoc.keywords.length >= 15) {
      setErrorMessages((prev) => ({
        ...prev,
        [filePath]: currentDoc.keywords.includes(trimmedKeywordValue)
          ? "This keyword already exists!"
          : "You can add a maximum of 15 keywords!",
      }));
      return;
    }

    const data = { envelope_id: parseFloat(envelopeId), file_name: selectedDoc.file_name, keyword: trimmedKeywordValue };
    addkeyword(data)
      .then(() => {
        setFetchedDocuments((prevDocs) =>
          prevDocs.map((doc) =>
            doc.file_path === filePath
              ? { ...doc, keywords: [...doc.keywords, trimmedKeywordValue] }
              : doc
          )
        );
        if (selectedDoc?.file_path === filePath) {
          setSelectedDoc((prevDoc) => ({
            ...prevDoc,
            keywords: [...prevDoc.keywords, trimmedKeywordValue],
          }));
        }
        setErrorMessages((prev) => ({ ...prev, [filePath]: "" }));
        // No need to re-fetch all documents, local state is updated.
      })
      .catch(() => setErrorMessages((prev) => ({ ...prev, [filePath]: "Error adding keyword. Please try again." })))
      .finally(() => setTagInputs((prev) => ({ ...prev, [filePath]: "" })));
  };

  const removeKeyword = (doc, keyword) => {
    const data = { envelope_id: parseFloat(doc.envelope_id), file_name: doc.file_name, keyword };
    deletekeyword(data)
      .then(() => {
        setFetchedDocuments((prevDocs) =>
          prevDocs.map((d) =>
            d.file_name === doc.file_name ? { ...d, keywords: d.keywords.filter((k) => k !== keyword) } : d
          )
        );
        if (selectedDoc && selectedDoc.file_name === doc.file_name)
          setSelectedDoc((prev) => ({ ...prev, keywords: prev.keywords.filter((k) => k !== keyword) }));
        // No need to re-fetch all documents, local state is updated.
      })
      .catch(() => toast.error("Failed to remove keyword."));
  };

  const handleOpenModal = (doc) => {
    if (doc && doc.file_path && doc.envelopeId) {
      setSelectedDoc(doc);
      setEnvelopeId(doc.envelopeId);
      setTagInputs({ [doc.file_path]: "" });
      setTagModal(true);
    } else {
      setErrorMessages((prev) => ({
        ...prev,
        [doc.file_path]: "Invalid document data. Sleeve ID is missing.",
      }));
    }
  };

  const handleCloseModal = () => {
    setTagModal(false);
    setSelectedDoc(null);
    setTagInputs({});
    setErrorMessages({});
  };

  const handleKeyPress = (e, filePath) => {
    if (e.key === "Enter") saveKeyword(filePath, tagInputs[filePath]);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchText(value);
    setDataParams((prev) => ({ ...prev, page: 1 }));
    // Filtering will now be handled by useMemo, no need to call fetchDocuments here.
  };

  const handleOpenSummaryModal = (doc) => {
    if (!doc || !doc.file_path || !doc.envelopeId) {
      toast.error("Invalid document or missing envelope ID.");
      return;
    }

    const summaryData = {
      envelope_id: doc.envelopeId,
      user_id: selectedUserId,
      file_name: doc.file_name,
      file_path: doc.file_path,
    };

    sessionStorage.setItem("summaryData", JSON.stringify(summaryData));

    const randomId = Math.floor(Math.random() * 1000000);
    const summaryUrl = `/manage/sleeves-files/summary/${randomId}`;

    // ✅ Same tab me redirect
    navigate(summaryUrl);
  };

  const handleOpenDocumentModal = async (doc) => {
    if (!doc || !doc.file_path) return;

    try {
      setLoading(true);
      const fileNameLower = doc.file_name.toLowerCase();

      // PDF Files
      if (fileNameLower.endsWith(".pdf")) {
        setSelectedDocForPreview(doc);
        setShowDocumentModal(true);
      }
      // Word Documents
      else if (fileNameLower.endsWith(".docx") || fileNameLower.endsWith(".doc")) {
        const response = await fetch(doc.file_path);
        const arrayBuffer = await response.arrayBuffer();
        const result = await mammoth.convertToHtml({ arrayBuffer });
        setSelectedDocForPreview({ ...doc, content: result.value });
        setShowDocumentModal(true);
      }
      // PowerPoint Files
      else if (fileNameLower.endsWith(".pptx") || fileNameLower.endsWith(".ppt")) {
        // No preprocessing needed for PowerPoint files - they're handled by the PowerPointPreview component
        setSelectedDocForPreview(doc);
        setShowDocumentModal(true);
      }
      // Excel Files
      else if (fileNameLower.endsWith(".xlsx") || fileNameLower.endsWith(".xls")) {
        // Excel files are handled by the ExcelPreview component
        setSelectedDocForPreview(doc);
        setShowDocumentModal(true);
      }
      // CSV Files - handle separately from Excel for better preview
      else if (fileNameLower.endsWith(".csv")) {
        try {
          // For CSV files, we'll fetch the raw text content but let the ExcelPreview component parse it
          const response = await fetch(doc.file_path);
          if (!response.ok) throw new Error('Failed to fetch CSV file');
          const csvText = await response.text();

          // Just set the document and let the ExcelPreview component handle CSV parsing
          setSelectedDocForPreview(doc);
          setShowDocumentModal(true);
        } catch (csvError) {
          console.error("CSV parsing error:", csvError);
          // Fallback to normal preview if CSV parsing fails
          setSelectedDocForPreview(doc);
          setShowDocumentModal(true);
        }
      }
      // Text Files
      else if (fileNameLower.endsWith(".txt") || fileNameLower.endsWith(".rtf")) {
        const response = await fetch(doc.file_path);
        const text = await response.text();
        setSelectedDocForPreview({ ...doc, content: text });
        setShowDocumentModal(true);
      }
      // Image Files
      else if ([".jpg", ".jpeg", ".png", ".webp", ".gif"].some((ext) => fileNameLower.endsWith(ext))) {
        setSelectedDocForPreview(doc);
        setShowDocumentModal(true);
      } else {
        toast.error("Preview not available for this file type.");
      }
    } catch (error) {
      console.error("Error loading document:", error);
      toast.error("Error loading document. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleCloseDocumentModal = () => {
    setShowDocumentModal(false);
    setSelectedDocForPreview(null);
  };

  const handleOpenEditor = (doc) => {
    setEditorDoc(doc);
    setIsEditorOpen(true);
  };

  const toggleExpand = (index) => {
    setExpandedRows((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const handleDeleteTag = (index) => {
    const newTags = tags.filter((_, i) => i !== index);
    setTags(newTags);
    setDataParams((prev) => ({ ...prev, page: 1 }));
    // Filtering will now be handled by useMemo, no need to call fetchDocuments here.
  };

  const normalizeKeywords = (keywords) => {
    if (Array.isArray(keywords)) {
      return keywords.map((kw) => String(kw).trim()).filter((k) => k);
    }
    if (typeof keywords === "string") {
      return keywords.split(/\s*,\s*/).map((k) => k.trim()).filter((k) => k);
    }
    return [];
  };

  const fetchDocuments = (query = "", page = dataParams?.page, limit = dataParams?.limit) => {
    if (!selectedUserId) return;

    setLoading(true);

    const processDocuments = (docs) => {
      return docs.map((doc) => ({
        ...doc,
        sleeve_name: doc.sleeve_name ? String(doc.sleeve_name) : "N/A",
        document_type: doc.document_type ? String(doc.document_type) : "N/A",
        keywords: Array.isArray(doc.keywords)
          ? doc.keywords.flatMap((kw) => (typeof kw === "string" ? kw.split(/,\s*/) : [String(kw)]))
          : doc.keywords
            ? String(doc.keywords).split(/,\s*/).filter((k) => k)
            : [],
        envelopeId: doc.envelope_id || null,
        fileName: doc.file_name || "",
        hasDetails: doc.hasDetails || false,
      }));
    };

    const handleResponse = (response) => {
      const docs = response?.data?.data || [];
      const processedDocs = processDocuments(docs);
      setFetchedDocuments(processedDocs);
      // Ensure ss_data is a valid object, default to empty object if invalid
      setSleeveSmartFoldersData(
        response?.data?.ss_data && typeof response.data.ss_data === 'object' && !Array.isArray(response.data.ss_data)
          ? response.data.ss_data
          : {}
      );
      const total = response?.data?.count || processedDocs.length;
      // setTotalDocuments(total); // This will be set based on filteredAndSearchedDocuments.length
      setTotalSleeveFiles(total);
    };

    const handleError = () => {
      setFetchedDocuments([]);
      setSleeveSmartFoldersData({});
      setTotalDocuments(0);
      setTotalSleeveFiles(0);
      // toast.error("Failed to fetch documents.");
    };

    // Always fetch all documents, then filter client-side
    getDocuments({ email: Utils.loginUserData()?.email, user_id: Number(selectedUserId), page: 1, limit: 100000 }) // Fetch large number to ensure all are available for client-side filtering
      .then(handleResponse)
      .catch(handleError)
      .finally(() => setLoading(false));
  };

  const highlightText = (text, searchTerms) => {
    if (text === null || text === undefined) return "N/A";
    const textStr = String(text);

    const allSearchTerms = [...(searchText ? [searchText.trim()] : []), ...tags].filter((term) => term.trim());

    if (!allSearchTerms || allSearchTerms.length === 0) return textStr;

    const escapedTerms = allSearchTerms.map((term) => term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
    const regex = new RegExp(`(${escapedTerms.join("|")})`, "gi");
    const parts = textStr.split(regex);

    return parts.map((part, index) =>
      regex.test(part) ? (
        <span
          key={index}
          style={{
            backgroundColor: "#FFD700",
            color: "black",
            fontWeight: "bold",
          }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  useEffect(() => {
    // Update totalDocuments whenever filteredAndSearchedDocuments changes
    setTotalDocuments(filteredAndSearchedDocuments.length);
  }, [filteredAndSearchedDocuments]);

  return (
    <>
      {loading && (
        <div className="page-loading">
          <img src="/images/loader.gif" alt="loader" />
        </div>
      )}
      <section
        className="section-bg-color min-height-sleeve sleeve-spacing wrapper-sleeve"
      >
        <style>{styles}</style>
        <div className="custom_container">
          <div className="table_header_wrap">
            <div
              className="nav nav-tabs wrap_left flexWrap pb-0"
              id="nav-tab"
              role="tablist"
            >
              <button
                className="nav-link mb-3"
                onClick={() => navigate("/manage")}
                type="button"
                role="tab"
              >
                In Progress <span>({totalInProgress})</span>
              </button>
              <button
                className="nav-link mb-3"
                onClick={() => navigate("/manage/draft")}
                type="button"
                role="tab"
              >
                Draft <span>({totalDraft})</span>
              </button>
              <button
                className="nav-link mb-3"
                onClick={() => navigate("/manage/completed")}
                type="button"
                role="tab"
              >
                Completed <span>({totalCompleted})</span>
              </button>
              <button
                className="nav-link mb-3 active d-flex"
                onClick={() => navigate("/manage/files")}
                type="button"
                role="tab"
              >
                Sleeves Files
              </button>
              {/* My Files Button Logic */}
              {myFilesEnabled && (
                <button className="nav-link mb-3 d-flex" onClick={(e) => navigate('/manage/my-files')}
                  type="button" role="tab" aria-selected="true" >
                  My Files
                </button>
              )}
            </div>
            <div
              className="d-flex align-items-center bg-light rounded-2 border p-1 mb-3"
              style={{ width: "fit-content" }}
            >
              <button
                className={`btn d-flex align-items-center justify-content-center rounded-2 px-2 py-1 border-0 ${viewMode === "folder"
                  ? "bg-white text-dark shadow-sm"
                  : "bg-transparent text-primary"
                  }`}
                onClick={() => setViewMode("folder")}
                title="Folder View"
                style={{ minWidth: "35px", height: "35px" }}
              >
                <CiGrid41 size={20} />
              </button>
              <button
                className={`btn d-flex align-items-center justify-content-center rounded-2 px-2 py-1 border-0 ${viewMode === "table"
                  ? "bg-white text-dark shadow-sm"
                  : "bg-transparent text-primary"
                  }`}
                onClick={() => setViewMode("table")}
                title="Table View"
                style={{ minWidth: "35px", height: "35px" }}
              >
                {loading ? (
                  <div className="page-loading">
                    <img src="/images/loader.gif" alt="loader" />
                  </div>
                ) : (
                  <CiBoxList size={20} />
                )}
              </button>
            </div>
            {/* New Dropdown Filter */}
          </div>
          {viewMode === "table" ? (
            <div className="myfiles-tab-content position-relative bg-white mb-4 p-4 rounded">
              {/* <div className="container-fluid px-4 py-3"> */}
              <div>
                <div className="row">
                  <div className="col-md-8 col-12 mx-auto">
                    <div className="input-group position-relative mb-4">
                      <div
                        className="position-relative"
                        style={{ width: "100%", marginInline: "auto" }}
                      >
                        <div className="tags-input-container form-control mb-2 d-flex flex-wrap align-items-center rounded-2">
                          {tags.map((tag, index) => (
                            <span
                              key={index}
                              className="badge bg-primary text-white d-flex align-items-center px-2 py-1 me-1"
                            >
                              {tag}
                              <i
                                className="cursor-pointer ms-1 text-dark"
                                onClick={() => handleDeleteTag(index)}
                              ></i>
                            </span>
                          ))}
                          <input
                            type="text"
                            value={searchText}
                            onChange={handleInputChange}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" && searchText.trim()) {
                                const trimmedKeyword = searchText.trim();
                                if (
                                  !tags.some((tag) => tag === trimmedKeyword)
                                ) {
                                  const newTags = [...tags, trimmedKeyword];
                                  setTags(newTags);
                                  setDataParams((prev) => ({
                                    ...prev,
                                    page: 1,
                                  }));
                                }
                                setSearchText("");
                              }
                            }}
                            placeholder={
                              tags.length === 0 ? "Type to search..." : ""
                            }
                            className="border-0 outline-0 flex-grow-1"
                            style={{
                              minWidth: "150px",
                              borderRadius: "8px",
                              padding: "5px",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-12 d-block d-md-block d-lg-flex d-xl-flex d-xxl-flex d-xxxl-flex
                    justify-content-end">
                    <div className="dropdown ms-2" style={{ width: "150px" }}>
                      <button
                        className="btn btn-outline-secondary dropdown-toggle w-100"
                        type="button"
                        id="fileFilterDropdown"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        style={{ width: "100%", minWidth: "150px" }}
                      >
                        {fileFilterType === "all"
                          ? "All Files"
                          : fileFilterType === "normal"
                            ? "Normal Files"
                            : "Smart Files"}
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="fileFilterDropdown"
                        style={{
                          width: "100%",
                          minWidth: "150px",
                          maxHeight: "none", // disables scroll
                          overflowY: "visible", // disables scroll
                        }}
                      >
                        <li>
                          <a
                            className="dropdown-item"
                            onClick={(e) => {
                              e.preventDefault();
                              setFileFilterType("all");
                            }}
                          >
                            <RiFileList3Line
                              className="me-1"
                              style={{ verticalAlign: "middle" }}
                            />{" "}
                            All Files
                          </a>
                        </li>
                        <li>
                          <button
                            className="dropdown-item w-auto"
                            onClick={(e) => {
                              e.preventDefault();
                              setFileFilterType("normal");
                            }}
                          >
                            <FaRegFile
                              className="me-1"
                              style={{ verticalAlign: "middle" }}
                            />{" "}
                            Normal Files
                          </button>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            onClick={(e) => {
                              e.preventDefault();
                              setFileFilterType("smart");
                            }}
                          >
                            <BsLightningChargeFill
                              className="me-1"
                              style={{ verticalAlign: "middle" }}
                            />{" "}
                            Smart Files
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div>
                      {viewMode === "table" && selectedRows.length > 0 && userData.myfiles_enabled && (
                        <button
                          className="btn btn-primary ms-3"
                          onClick={() => setShowCopyModal(true)}
                        >
                          Copy to My Files
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {paginatedDocuments.length === 0 ? (
                <div className="no-documents-placeholder">
                  <p>No documents found.</p>
                </div>
              ) : (
                <div
                  style={{
                    overflowX: "auto",
                    width: "100%",
                    scrollbarWidth: "thin",
                  }}
                  className="table-responsive rounded-3 border"
                >
                  <table
                    className="table table-hover mb-0 in_progress_table" style={{ overflowX: "auto !important" }}
                  >
                    <thead className="table-light">
                      <tr>
                        <th style={{ width: "40px", textAlign: "center" }}>
                          <input
                            type="checkbox"
                            checked={
                              selectedRows.length ===
                              paginatedDocuments.length &&
                              paginatedDocuments.length > 0
                            }
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedRows(
                                  paginatedDocuments.map((doc) => doc.id)
                                );
                              } else {
                                setSelectedRows([]);
                              }
                            }}
                          />
                        </th>
                        <th style={{ textAlign: "center" }}>
                          Sleeve Name
                        </th>
                        <th style={{ textAlign: "center" }}>
                          File Name
                        </th>
                        <th style={{ textAlign: "center" }}>
                          Size
                        </th>
                        <th style={{ textAlign: "center" }}>
                          Document Type
                        </th>
                        <th style={{ textAlign: "center" }}>
                          Keywords{" "}
                          <i
                            className="bi bi-info-circle ms-2 text-muted cursor-pointer"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Once your documents are processed, AI automatically generates relevant keywords."
                          />
                        </th>
                        <th style={{ textAlign: "center" }}>
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedDocuments.map((doc, index) => {
                        const searchTerms = searchText
                          ? searchText.split(" ").filter((term) => term.trim())
                          : [];

                        return (
                          <tr key={index}>
                            <td className="text-center">
                              <input
                                type="checkbox"
                                checked={selectedRows.includes(doc.id)}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelectedRows((prev) => [
                                      ...prev,
                                      doc.id,
                                    ]);
                                  } else {
                                    setSelectedRows((prev) =>
                                      prev.filter((id) => id !== doc.id)
                                    );
                                  }
                                }}
                              />
                            </td>
                            {/* Sleeve Name */}
                            <td
                              className="text-center"
                            // style={{ minWidth: "180px" }}
                            >
                              <div className="d-flex align-items-center justify-content-center gap-2">
                                <span
                                  className="badge bg-secondary bg-opacity-10 text-dark px-3 py-2"
                                  style={{
                                    // maxWidth: "150px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title={doc.sleeve_name}
                                >
                                  {highlightText(doc.sleeve_name, searchTerms)}
                                </span>
                                {doc.is_smart_sleeve && (
                                  <span
                                    className="smart-sleeve-badge"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Smart Sleeve"
                                  >
                                    <i className="bi bi-lightning-fill"></i>SS
                                  </span>
                                )}
                              </div>
                            </td>

                            {/* File Name with Tooltip */}
                            <td
                              className="text-center"
                              style={{ minWidth: "200px" }}
                            >
                              <div
                                className="text-truncate position-relative d-inline-block"
                                style={{ maxWidth: "200px" }}
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title={doc.file_name}
                              >
                                <button
                                  className="btn btn-link text-primary p-0 text-center text-truncate text-decoration-none"
                                  onClick={() => handleOpenDocumentModal(doc)}
                                  style={{ maxWidth: "100%" }}
                                >
                                  {highlightText(doc.file_name, searchTerms)}
                                </button>
                              </div>
                            </td>

                            {/* File Size */}
                            <td
                              className="text-center text-muted"
                            // style={{ minWidth: "100px" }}
                            >
                              <span>
                                {doc.file_size
                                  ? `${(doc.file_size / 1024).toFixed(2)} MB`
                                  : "—"}
                              </span>
                            </td>

                            {/* Document Type */}
                            <td
                              className="text-center"
                            // style={{ minWidth: "150px" }}
                            >
                              <span className="badge bg-info bg-opacity-10 text-info px-3 py-2">
                                {highlightText(doc.document_type, searchTerms)}
                              </span>
                            </td>

                            {/* Keywords */}
                            <td className="text-center" >
                              <div
                                className="d-flex justify-content-start align-items-center gap-2"
                                style={{
                                  flexWrap: expandedRows[index]
                                    ? "wrap"
                                    : "nowrap",
                                  overflowX: "auto",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {doc.keywords?.length > 0 ? (
                                  <>
                                    {doc.keywords
                                      .slice(
                                        0,
                                        expandedRows[index]
                                          ? doc.keywords.length
                                          : 2
                                      )
                                      .map((keyword, idx) => (
                                        <div
                                          key={idx}
                                          className="badge rounded bg-light text-primary d-flex align-items-center px-2 py-1"
                                          style={{ flexShrink: 0 }}
                                        >
                                          <span className="me-2">
                                            {highlightText(
                                              keyword,
                                              searchTerms
                                            )}
                                          </span>
                                          <FaTimes
                                            className="cursor-pointer ms-1 text-dark"
                                            onClick={() =>
                                              removeKeyword(doc, keyword)
                                            }
                                          />
                                        </div>
                                      ))}
                                    {doc.keywords.length > 2 && (
                                      <button
                                        className="btn btn-sm btn-outline-primary rounded-pill py-1 px-3"
                                        onClick={() => toggleExpand(index)}
                                        style={{
                                          fontSize: "0.8rem",
                                          whiteSpace: "nowrap",
                                          // flexShrink: 0,
                                        }}
                                      >
                                        {expandedRows[index]
                                          ? "Show Less"
                                          : `Show More+${doc.keywords.length - 3
                                          }`}
                                      </button>
                                    )}
                                  </>
                                ) : (
                                  <span className="text-muted">
                                    No keywords
                                  </span>
                                )}
                              </div>
                            </td>

                            {/* Actions */}
                            <td className="text-center" style={{ minWidth: "80px" }}>
                              <Dropdown
                                trigger={['click']}
                                overlay={
                                  <Menu className="custom-rc-dropdown-menu">
                                    <MenuItem key="add-tag" className="custom-rc-dropdown-item">
                                      <span
                                        className="d-flex align-items-center"
                                        onClick={() => handleOpenModal(doc)}
                                      >
                                        <i className="bi bi-tag me-2" /> Add Tag
                                      </span>
                                    </MenuItem>
                                    <MenuItem key="summary" className="custom-rc-dropdown-item">
                                      <span
                                        className="d-flex align-items-center"
                                        onClick={() => handleOpenSummaryModal(doc)}
                                      >
                                        <i className="bi bi-file-text me-2" /> Summary
                                      </span>
                                    </MenuItem>
                                    <MenuItem key="edit-details" className="custom-rc-dropdown-item">
                                      <span
                                        className="d-flex align-items-center"
                                        onClick={() => handleOpenFormOffcanvas(doc)}
                                      >
                                        <i className="bi bi-pencil me-2" /> {doc.hasDetails ? "Edit" : "Add"} Details
                                      </span>
                                    </MenuItem>
                                    <MenuItem key="view-details" className="custom-rc-dropdown-item">
                                      <span
                                        className="d-flex align-items-center"
                                        onClick={() => handleOpenDetailsOffcanvas(doc)}
                                      >
                                        <i className="bi bi-eye me-2" /> View Details
                                      </span>
                                    </MenuItem>
                                  </Menu>
                                }
                                animation="slide-up"
                              >
                                <button
                                  className="rounded cur-pointer"
                                  type="button"
                                  style={{ width: "32px", height: "32px" }}
                                >
                                  <i className="bi bi-three-dots-vertical" />
                                </button>
                              </Dropdown>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          ) : (
            <div>
              <EnvFilesFolderView
                documents={paginatedDocuments}
                handleOpenDocumentModal={handleOpenDocumentModal}
                highlightText={highlightText}
                searchText={searchText}
                sleeveSmartFoldersData={sleeveSmartFoldersData}
                onSearchChange={handleSearchChange}
                onRefreshDocuments={() => fetchDocuments(searchText)}
                userId={selectedUserId}
              />
            </div>
          )}
          {totalDocuments > dataParams.limit && viewMode === "table" && (
            <div className="table_footer_wrap mt-4">
              <div className="d-flex align-items-center">
                <span className="me-2 text-white fw-bolder fs-6">Show</span>
                <select
                  className="form-select"
                  value={dataParams.limit}
                  onChange={(e) => handleData(e, "limit")}
                  style={{ width: "80px" }}
                >
                  {lengths.map((item, i) => (
                    <option value={item} key={i}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
              <div className="pagination mt-3">
                <Pagination
                  activePage={dataParams.page}
                  itemsCountPerPage={dataParams.limit}
                  totalItemsCount={totalDocuments}
                  pageRangeDisplayed={5}
                  onChange={(e) => handleData(e, "pagination")}
                />
              </div>
            </div>
          )}
        </div>
        <div
          className={`offcanvas offcanvas-end ${formOffcanvasOpen ? "show" : ""
            }`}
          tabIndex="-1"
          id="formOffcanvas"
          style={{
            visibility: formOffcanvasOpen ? "visible" : "hidden",
            minWidth: "50%",
          }}
        >
          <DocumentForm
            doc={selectedFormDoc}
            storedFileName={selectedFormDoc?.file_name}
            formData={formData}
            setFormData={setFormData}
            onClose={handleCloseFormOffcanvas}
            commonFields={commonFields}
            documentFields={documentFields}
            onSubmit={handleSubmitForm}
            isEdit={selectedFormDoc?.hasDetails || false}
            isViewOnly={false}
          />
        </div>
        <div
          className={`offcanvas offcanvas-end ${detailsOffcanvasOpen ? "show" : ""
            }`}
          tabIndex="-1"
          id="detailsOffcanvas"
          style={{
            visibility: detailsOffcanvasOpen ? "visible" : "hidden",
            minWidth: "50%",
          }}
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title">
              Details for {selectedFormDoc?.file_name}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={handleCloseDetailsOffcanvas}
            ></button>
          </div>
          <div className="offcanvas-body">
            {formLoading ? (
              <p>Loading details...</p>
            ) : (
              <>
                <table className="table table-bordered">
                  <thead className="thead-light">
                    <tr>
                      <th scope="col" style={{ width: "40%" }}>
                        Field
                      </th>
                      <th scope="col" style={{ width: "60%" }}>
                        Value
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {commonFields.map((field) => (
                      <tr key={field.name}>
                        <td>{field.label}</td>
                        <td>{formDetails[field.name] || "-"}</td>
                      </tr>
                    ))}
                    {formDetails.additional_data &&
                      Object.entries(formDetails.additional_data).map(
                        ([key, value]) => (
                          <tr key={key}>
                            <td>
                              {key
                                .replace(/_/g, " ")
                                .replace(/\b\w/g, (c) => c.toUpperCase())}
                            </td>
                            <td>{value || "-"}</td>
                          </tr>
                        )
                      )}
                  </tbody>
                </table>
                <div className="mt-4">
                  <button
                    className="btn btn-primary me-2"
                    onClick={() => {
                      if (!selectedFormDoc) {
                        toast.error("No document selected to edit.");
                        return;
                      }
                      setFormData({
                        ...formDetails,
                        additional_data: formDetails.additional_data || {},
                      });
                      setStoredFileId(selectedFormDoc.id);
                      handleCloseDetailsOffcanvas();
                      handleOpenFormOffcanvas(selectedFormDoc);
                    }}
                  >
                    Edit Details
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={handleCloseDetailsOffcanvas}
                  >
                    Close
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </section>

      {showDocumentModal && (
        <div className="documents-modal-overlay">
          <div className="documents-modal-content">
            <div className="documents-modal-header">
              <h4>Document Preview</h4>
              <button onClick={handleCloseDocumentModal}>
                <FaTimes />
              </button>
            </div>
            <div className="documents-modal-body">
              {selectedDocForPreview?.file_name?.toLowerCase().endsWith(".pdf") ? (
                <div className="pdf-viewer-container">
                  <div className="pdf-wrapper">
                    <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                      <Viewer
                        fileUrl={selectedDocForPreview.file_path}
                        plugins={[defaultLayoutPluginInstance]}
                      />
                    </Worker>
                  </div>
                </div>
              ) : selectedDocForPreview?.file_name?.toLowerCase().match(/\.(docx?|rtf)$/) ? (
                <div className="docx-content" dangerouslySetInnerHTML={{ __html: selectedDocForPreview.content }} />
              ) : selectedDocForPreview?.file_name?.toLowerCase().match(/\.(pptx?|pps|ppsx)$/) ? (
                <PowerPointPreview filePath={selectedDocForPreview.file_path} />
              ) : selectedDocForPreview?.file_name?.toLowerCase().match(/\.xlsx$/) ? (
                <ExcelPreview filePath={selectedDocForPreview.file_path} />
              ) : selectedDocForPreview?.file_name?.toLowerCase().endsWith(".csv") ? (
                <ExcelPreview filePath={selectedDocForPreview.file_path} />
              ) : selectedDocForPreview?.file_name?.toLowerCase().endsWith(".txt") ? (
                <div className="text-content" style={{ whiteSpace: "pre-wrap", padding: "20px", backgroundColor: "#fff" }}>
                  {selectedDocForPreview.content}
                </div>
              ) : [".jpg", ".jpeg", ".png", ".webp", ".gif"].some((ext) =>
                selectedDocForPreview?.file_name?.toLowerCase().endsWith(ext)
              ) ? (
                <div className="image-preview text-center">
                  <img
                    src={selectedDocForPreview.file_path}
                    alt={selectedDocForPreview.file_name}
                    style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }}
                  />
                </div>
              ) : (
                <div className="text-center">
                  <p>Preview not available for this file type.</p>
                  <a
                    href={selectedDocForPreview?.file_path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="download-btn"
                  >
                    Download File
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {tagModal && (
        <div className="tag-modal-overlay">
          <div className="tag-modal-content">
            <div className="tag-modal-header">
              <h4>Manage Tags</h4>
              <button onClick={handleCloseModal}>
                <FaTimes />
              </button>
            </div>
            <div className="tag-modal-body">
              {selectedDoc && (
                <>
                  <div className="mb-3">
                    <strong>File:</strong> {selectedDoc.file_name}
                  </div>
                  <div className="mb-3">
                    <strong>Keywords:</strong>
                    {selectedDoc.keywords.map((keyword, index) => (
                      <span
                        key={index}
                        className="badge me-1 bg-primary mb-2 ms-2"
                      >
                        {keyword}
                        <FaTimes
                          className="cursor-pointer text-dark ms-2"
                          onClick={() => removeKeyword(selectedDoc, keyword)}
                        />
                      </span>
                    ))}
                  </div>
                  <div className="form-group mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter tag name"
                      value={tagInputs[selectedDoc.file_path] || ""}
                      onChange={(e) =>
                        setTagInputs((prev) => ({
                          ...prev,
                          [selectedDoc.file_path]: e.target.value,
                        }))
                      }
                      onKeyPress={(e) =>
                        handleKeyPress(e, selectedDoc.file_path)
                      }
                    />
                  </div>
                  {errorMessages[selectedDoc.file_path] && (
                    <p className="text-danger">
                      {errorMessages[selectedDoc.file_path]}
                    </p>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}

      <PasteToMyFilesModal
        show={showCopyModal}
        handleClose={() => setShowCopyModal(false)}
        itemsToPaste={(() => {
          const selectedDocs = paginatedDocuments.filter((d) => selectedRows.includes(d.id));
          const envelopeIds = Array.from(new Set(selectedDocs.map((doc) => Number(doc.envelope_id)).filter(Boolean)));
          const fileIds = selectedDocs.map((doc) => Number(doc.id)).filter(Boolean);
          return selectedDocs.length > 0
            ? [{
              user_id: selectedUserId,
              envelope_id: envelopeIds,
              file_ids: fileIds,
              target_folder_id: null,
            }]
            : [];
        })()}
        userId={selectedUserId}
        onPasteSuccess={() => {
          setShowCopyModal(false);
          setSelectedRows([]);
          // Optionally refresh documents
          fetchDocuments(searchText);
        }}
      />
    </>
  );
};

export default EnvFiles;